import React from 'react';
import { Table, Button, Offcanvas, Container } from 'react-bootstrap';

const ReceiptDraw = ({ show, onHide, data }) => {
    if (!data) {
        return null; // Do not render the modal if no data is available
    }

    const { header = {}, invoice = {}, items = [], totals = {}, footer = {} } = data;

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title className='text-center' >{header?.title || 'Receipt'}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='receipt-body'>
                <Container className='receipt'>
                    <div className="text-center">
                        <p>{header?.address || 'No Address Provided'}</p>
                        <p>Phone: {header?.phone || 'No Phone Provided'}</p>
                    </div>
                    <hr />
                    <div>
                        <p>
                            <strong>Order Number:</strong> {invoice?.orderNumber || 'N/A'} <br />
                            <strong>Employee:</strong> {invoice?.employee || 'N/A'} <br />
                            <strong>Date & Time:</strong> {invoice?.date || 'N/A'}
                        </p>
                    </div>
                    <Table hover responsive size="sm">
                        <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>MRP</th>
                                <th>Price</th>
                                <th>Qty</th>
                                <th>Amount</th>
                                <th>Saved on MRP</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.length > 0 ? (
                                items.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.name || item.item_name}</td>
                                        <td>₹{item.mrp}</td>
                                        <td>₹{item.price}</td>
                                        <td>{item.qty || item.quantity}</td>
                                        <td>₹{item.amt || item.amount}</td>
                                        <td>₹{item?.saved_on_mrp || 0}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        No Items Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    <hr />
                    <div>
                        <p>
                            <strong>Total Amount:</strong> ₹{totals?.totalAmt || 0} <br />
                            <strong>Total Items:</strong> {totals?.totalItems || 0} <br />
                            <strong>Total Quantity:</strong> {totals?.totalQty || 0} <br />
                            <strong>Total Savings:</strong> ₹{totals?.totalSavings || 0}
                        </p>
                    </div>
                    <hr />
                    <div className="text-center">
                        <p>{footer?.exchangeReturn || ''}</p>
                        <p>{footer?.billMandatory || ''}</p>
                        <p>{footer?.deliveryContact || ''}</p>
                        <p>{footer?.techPartner || ''}</p>
                    </div>
                </Container>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ReceiptDraw;